'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Backdrop": "Polaris-Backdrop",
  "transparent": "Polaris-Backdrop--transparent",
  "belowNavigation": "Polaris-Backdrop--belowNavigation"
};

exports.default = styles;
